export const {
  PUBLIC_URL,
  REACT_APP_BASE_URL,
  REACT_APP_OLD_URL,
  REACT_APP_API_BASE_URL,
  REACT_APP_DA_ABOUT_URL,
  REACT_APP_CHC_URL,
  REACT_APP_CAPACITACION_URL,
  REACT_APP_CENTROAYUDA_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_FEATURE_FLAG_ABOUT_PAGE,
  REACT_APP_FEATURE_FLAG_DOWNLOADS_PAGE,
  REACT_APP_FEATURE_FLAG_PROVIDERS_PAGE,
  REACT_APP_FEATURE_FLAG_REGIONAL_INFO_PAGE,
  REACT_APP_FEATURE_FLAG_SECTORS_PAGE,
  REACT_APP_FEATURE_FLAG_SELECT_ORGANISM_TYPE,
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_DATATABLE,
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_EXPENSE_DOWNLOAD,
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_HOME,
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_SELECT_OPTIONS,
  REACT_APP_FEATURE_FLAG_TYPE_PURCHASE_MENU,
  REACT_APP_FEATURE_FLAG_SMALLER_COMPANIES_MENU,
  REACT_APP_FEATURE_FLAG_NEW_SECTION,
  REACT_APP_FEATURE_FLAG_MARQUEE,
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION,
  REACT_APP_MP_URL,
  REACT_APP_API_URL,
  REACT_APP_MP_API_URL,
  REACT_APP_MP_APIS_DOCUMENTATION_URL,
  REACT_APP_REQUEST_DATA_FORM_URL,
  REACT_APP_SUPPLIER_PROFILE_BASE_URL,
  REACT_APP_VIDEO_BUYERPROFILE,
  REACT_APP_VIDEO_COMPARATOR,
  REACT_APP_VIDEO_GENERAL,
  REACT_APP_VIDEO_PLATFORM,
  REACT_APP_ALLBUYERS_URL,
  REACT_APP_OCDS_BASE_URL,
  REACT_APP_OCDS_IMAGE,
  REACT_APP_OCDS_TERMS_URL,
  REACT_APP_OCDS_QUERYTYPE_URL,
  REACT_APP_OCDS_QUERYLIST_URL,
  REACT_APP_OCDS_REPOSITORY_URL,
  REACT_APP_OCDS_METADATA_URL,
  REACT_APP_DATA_CM_MASTER_URL,
  REACT_APP_DATA_COIN_ERROR_URL,
  REACT_APP_DATA_AMOUNT_ERROR_URL,
  REACT_APP_DATA_HISTORIC_COIN_URL,
  REACT_APP_DATA_ITEMS_ONU_URL,
  REACT_APP_DATA_HISTORIC_BUYERS_URL,
  REACT_APP_DATA_SECONDARY,
  REACT_APP_ABOUT_SITEGOAL,
  REACT_APP_ABOUT_DEFINITIONS,
  REACT_APP_CENTRALBANK,
  REACT_APP_MAIL_DIRECTION,
  REACT_APP_RRSS_FACEBOOK,
  REACT_APP_RRSS_TWITTER,
  REACT_APP_RRSS_LINKEDIN,
  REACT_APP_RRSS_YOUTUBE,
  REACT_APP_CONDITIONS_URL,
  REACT_APP_MP_SEARCH,
  REACT_APP_MP_DEVELOPERS,
  REACT_APP_MP_HELP_URL,
  REACT_APP_SEARCH_BIDDINGS_URL,
  REACT_APP_SEARCH_OC_URL,
  REACT_APP_DLPP_URL,
  REACT_APP_PAC_URL,
  REACT_APP_PURCHASE_PLAN_URL,
  REACT_APP_TCHC_BLOB_URL,
  REACT_APP_TCMARCOH_URL,
  REACT_APP_OCDS_BLOB_URL,
  REACT_APP_OCDS_MP_URL,
  REACT_APP_FEATURE_FLAG_NEW_SECTION_AGILE_PURCHASE
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
